export const isRequestQuotePath = (pathname: string) => pathname.includes('/request-quote/');
